import { OuiSelectOption } from 'omnium-ui/form-field';
import { AssureurType, RcpType } from './piece-justificative-rcp.model';

export const assureurOptions: OuiSelectOption<AssureurType>[] = [
  { label: 'ZURICH INSURANCE PLC', value: '1' },
  { label: 'MMA IARD', value: '2' },
  { label: 'Autre', value: '3' },
];

export const rcpMultiOptions: OuiSelectOption<RcpType>[] = [
  { label: 'RCP Assurance', value: 'RcpAssurance' },
  { label: 'RCP CIF', value: 'RcpCif' },
  { label: 'RCP Immobilier', value: 'RcpImmobilier' },
  { label: 'RCP IOB', value: 'RcpIob' },
];
